<template>
  <div class="storePage">
    <div class="pageTop">
      <h1>景区指标</h1>
      <div class="pageTopMain">
        <div class="pageTopFilters">
          <!-- <h2 class="countrySel">地区选择</h2>
          <el-select v-model="region" placeholder="请选择">
            <el-option v-for="item in countryList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select> -->
          <h2>景区选择</h2>
          <SearchSelect
            className="longSelect"
            v-model="store"
            :options="storeOptions"
            :props="{
              label: 'label',
              value: 'value',
            }"
            placeholder="请选择景区"
          />
          <h2>ERP仓库</h2>
          <search-select
            className="longSelect"
            v-model="erpstore"
            :options="allErpStore"
            :props="{
              label: 'store_name',
              value: 'store_id',
            }"
            placeholder="请选择ERP仓库"
          />

          <el-select
            class="mineSelect"
            v-model="category"
            placeholder="请选择"
            multiple
            v-collapse-tags="2"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-date-picker
            v-model="dateValue"
            type="daterange"
            align="right"
            unlink-panels
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="dateChange"
            :clearable="false"
          >
          </el-date-picker>
          <h2>指标筛选</h2>
          <el-select class="mineSelect" v-model="quota" placeholder="请选择">
            <el-option
              v-for="item in quotaOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="pageTopActions">
          <el-button @click="handleQuery">查询</el-button>
          <el-button @click="handleDownload" icon="el-icon-download"
            >下载</el-button
          >
        </div>
      </div>
    </div>
    <div class="pageTable">
      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 20px"
        border
        height="600"
      >
        <el-table-column align="center" label="景区名称" prop="name" />
        <el-table-column align="center" label="ERP仓库名称" prop="store_name" />
        <el-table-column align="center" :label="`销售额(${unit})`" prop="money" sortable />
        <el-table-column
          align="center"
          label="有售设备数"
          prop="sold"
          sortable
        />
        <el-table-column
          align="center"
          label="设备均销售"
          prop="averageMoney"
          sortable
        >
          <template slot-scope="scope">
            {{
              scope.row.averageMoney.toFixed(2).toString().split(".")[1] == "00"
                ? scope.row.averageMoney.toFixed(0)
                : scope.row.averageMoney.toFixed(2)
            }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="实际销量"
          prop="amount"
          sortable
        />
        <el-table-column
          align="center"
          label="设备均销量"
          prop="averageAmount"
          sortable
        >
          <template slot-scope="scope">
            {{
              scope.row.averageAmount.toFixed(2).toString().split(".")[1] ==
              "00"
                ? scope.row.averageAmount.toFixed(0)
                : scope.row.averageAmount.toFixed(2)
            }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="销售款式数"
          prop="type"
          sortable
        />
        <el-table-column align="center" label="退款数" prop="refund" sortable />
        <el-table-column
          align="center"
          label="退款率"
          prop="refundRate"
          sortable
          :sort-method="customSort"
        >
        </el-table-column>
      </el-table>
      <EchartsNine ref="storeQuota" :params="params"></EchartsNine>
    </div>
  </div>
</template>

<script>
import EchartsNine from "./EchartsNine";
import SearchSelect from "@/views/components/SearchSelect";
import { getStoreDownload, getSalesList, getErpStoreList } from "@/api/bi";

export default {
  name: "StoreQuota",
  data() {
    return {
      region: '0', // 国家
      countryList: [
        { value: '0', label: '全部' },
        { value: '1', label: '中国大陆' },
        { value: '2', label: '中国香港' },
        { value: '3', label: '中国澳门' },
        { value: '4', label: '中国台湾' },
        { value: '5', label: '阿联酋' },
        { value: '6', label: '美国' },
        { value: '7', label: '韩国' },
      ],
      unit: '元', // 单位
      unitList: {
        0: '元',
        1: '元',
        2: '港元',
        3: '澳元',
        4: '台币',
        5: '迪拉姆',
        6: '美元',
        7: '韩元',
      },
      dateValue: [],
      store: "",
      erpstore: "",
      allErpStore: [],
      category: ["1", "2", "3", "4","5","6","7","8"],
      options: [
        { value: "1", label: "771/772" },
        { value: "2", label: "775" },
        { value: "3", label: "776" },
        { value: "4", label: "779" },
        { value: "5", label: "780" },
        { value: "6", label: "781" },
        { value: "7", label: "782" },
        { value: "8", label: "783" }
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ]
      },
      tableData: [], // 表格数据
      quota: "1",
      quotaOptions: [
        { value: "1", label: "设备销售额" },
        { value: "2", label: "退款率" },
      ],
    };
  },
  created() {
    this.setRangeDates();
    this.loadErpStoreList();
  },
  props: ["allStore"], // 全部景区列表
  beforeMount() {
    this.fetchData();
  },
  watch: {
    // 部门变更后父组件刷新 allStore，清空已选景区（避免残留无效 id）
    allStore() {
      this.store = "";
    },
  },
  methods: {
    // 随部门变更刷新 ERP 仓库列表（接口自动带 targetid）
    loadErpStoreList() {
      this.erpstore = "";
      return getErpStoreList()
        .then((res) => {
          // 接口可能返回 data: {}，保证下拉 options 始终为数组
          if (res && res.code === 2000 && Array.isArray(res.data)) {
            this.allErpStore = res.data;
          } else {
            this.allErpStore = [];
          }
          return res;
        })
        .catch((e) => {
          console.error("获取ERP仓库列表失败", e);
          this.allErpStore = [];
          return null;
        });
    },
    setRangeDates() {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth(); // 月份从0开始，0为1月
      const day = today.getDate();

      let startDate, endDate;

      if (month === 0 && day === 1) {
        // 如果今天是1月1日，起始和结束日期为去年12月的1号和31号
        startDate = new Date(year - 1, 11, 1);
        endDate = new Date(year - 1, 11, 31);
      } else if (day === 1) {
        // 如果今天是一个月的1号，起始日期为上一个月的1号，结束日期为上一个月的最后一天
        startDate = new Date(year, month - 1, 1);
        endDate = new Date(year, month, 0); // 设置日期为0将自动设置为上个月的最后一天
        console.log(1111111, endDate);
      } else {
        // 如果今天是一个月中的其他日期，起始日期为这个月的1号，结束日期为昨天
        startDate = new Date(year, month, 1);
        endDate = new Date(year, month, day - 1);
      }

      this.dateValue = [this.formatDate(startDate), this.formatDate(endDate)];
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    // 清除el-select搜索文本框的值query
    // onSelectChange() {
    //   this.$refs['el-select2'].query = ''
    // },
    // handleSelect(val){ // 接收来自组件的数据
    //   console.log('最新景区', val)
    //   this.store = val;
    // },
    // handleSelectDevice(val){ // 设备
    //   console.log('最新设备', val)
    //   this.device = val;
    // },
    handleQuery() {
      this.fetchData();
      this.$refs.storeQuota && this.$refs.storeQuota.initData && this.$refs.storeQuota.initData();
    },

    dateChange(val) {
      const [start, end] = val;
      console.log(start, end);
      console.log(this.dateValue);
    },
    fetchData() {
      this.unit = this.unitList[this.region];
      // 先清空，避免失败时仍展示上一份数据
      this.tableData = [];
      const params = {
        start: this.dateValue && this.dateValue[0], // 开始日期
        end: this.dateValue && this.dateValue[1], // 结束日期
        source: this.category || undefined, // 来源 1 纪念币， 2 大牌
        company_id_list: this.store || undefined, // 景区id
        store_id_list: this.erpstore || undefined, // ERP仓库id
        region_id: this.region * 1, // 区域id
      };
      return getSalesList(params)
        .then((res) => {
          if (res && res.code === 2000 && res.data && Array.isArray(res.data)) {
            this.tableData = res.data;
          } else {
            this.tableData = [];
          }
        })
        .catch((e) => {
          // code:-1 等业务失败：保持空表
          console.error("获取景区指标失败", e);
          this.tableData = [];
        });
    },
    customSort(a, b) {
      console.log(a, b);
      // 提取字符串中的数字部分进行比较
      const numA = parseFloat(a.refundRate.replace("%", ""));
      const numB = parseFloat(b.refundRate.replace("%", ""));

      // 进行数值比较
      return numA - numB;
    },
    handleDownload() {
      const params = {
        start: this.dateValue && this.dateValue[0], // 开始日期
        end: this.dateValue && this.dateValue[1], // 结束日期
        source: this.category || undefined, // 来源 1 纪念币， 2 大牌
        company_id_list: this.store || undefined, // 景区id
        store_id_list: this.erpstore || undefined, // ERP仓库id
        tp: this.quota || undefined, // 指标筛选
      };
      this.$confirm(`确认下载数据吗？`).then(() => {
        // 下载
        getStoreDownload(params)
          .then((data) => {
            this.download(data);
          })
          .catch((error) => {
            this.$message.error(error);
          });
      });
    },
    download(resp) {
      const fileName = "景区指标";
      const blob = new Blob([resp.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const href = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = href;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(a.href);
      }
    },
  },
  computed: {
    params() {
      // 父组件调用table子组件中的方法
      return {
        start: this.dateValue && this.dateValue[0], // 开始日期
        end: this.dateValue && this.dateValue[1], // 结束日期
        source: this.category || undefined, // 来源 1 纪念币， 2 大牌
        company_id_list: this.store || undefined, // 景区id
        store_id_list: this.erpstore || undefined, // ERP仓库id
        tp: this.quota || undefined, // 指标筛选
      };
    },
    storeOptions() {
      let arr = [];
      if (!Array.isArray(this.allStore)) return arr;
      this.allStore.map((val) => {
        arr.push({ label: val.name, value: val.id });
      });
      return arr;
    },
  },

  components: {
    SearchSelect,
    EchartsNine,
  },
};
</script>

<style scoped>
/** {*/
/*  scrollbar-width: thin;*/
/*  scrollbar-color: #58D9F9 #F5F5F5;*/
/*}*/
/* 改变滚动条的宽度和颜色 */
::-webkit-scrollbar {
  background-color: transparent;
  width: 10px;
  border: 1px solid;
  border-radius: 5px;
}
::-webkit-scrollbar-thumb {
  background-color: #58d9f9;
  border-radius: 5px;
}

/* 改变滚动条被悬停时的颜色 */
::-webkit-scrollbar-thumb:hover {
  background-color: #7cffb2;
}

/* 改变滚动条的轨道宽度和颜色 */
::-webkit-scrollbar-track {
  background-color: transparent;
  border-radius: 5px;
}

.pageTop {
  display: flex;
  margin-bottom: 10px;
  align-items: flex-start;
  flex-wrap: nowrap;
}

.pageTop h1 {
  margin-right: 30px;
  margin-top: 6px;
  font-size: 22px;
  font-weight: bold;
  flex-shrink: 0;
}

.pageTopMain {
  flex: 1;
  min-width: 0;
}

.pageTopFilters {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.pageTop h2 {
  margin: 0 10px;
}

.pageTopFilters h2:first-of-type {
  margin-left: 0;
}

.pageTop .mineSelect {
  margin: 0 10px;
}

.pageTopActions {
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 12px;
}

.pageTopActions .el-button {
  margin-left: 0;
  margin-right: 10px;
}

.storePage,
.deviceBox {
  font-size: 16px;
  color: #ffffff;
  padding: 20px;
  border: 1px solid #5c01b8;
  border-radius: 30px;
  width: 95%;
  margin: 10px auto;
}

.storePage {
  box-shadow: 0 0 10px;
  /*border-color: #58D9F9;*/
  margin-top: 30px;
}

.pageTable {
  margin-top: 40px;
}
.el-button {
  margin-left: 10px;
}

.el-button:hover {
  color: #ffffff;
  background-color: #5c01b8;
  border-color: #5c01b8;
}
</style>

<style>
/** {*/
/*  scrollbar-width: thin;*/
/*  scrollbar-color: #58D9F9 #F5F5F5;*/
/*}*/
/* 改变滚动条的宽度和颜色 */
.storePage ::-webkit-scrollbar {
  background-color: transparent;
  width: 10px;
  border: 1px solid;
  border-radius: 5px;
}
.storePage ::-webkit-scrollbar-thumb {
  background-color: #58d9f9;
  border-radius: 5px;
}

/* 改变滚动条被悬停时的颜色 */
.storePage ::-webkit-scrollbar-thumb:hover {
  background-color: #7cffb2;
}

/* 改变滚动条的轨道宽度和颜色 */
.storePage ::-webkit-scrollbar-track {
  background-color: transparent;
  border-radius: 5px;
}

.storePage .el-table {
  background: transparent !important;
  color: #fff;
  font-size: 16px;
}

.storePage .el-table tr {
  background: transparent;
}

.storePage .el-table th.el-table__cell {
  background: transparent !important;
  color: #fff;
}

.storePage
  .el-table--enable-row-hover
  .el-table__body
  tr:hover
  > td.el-table__cell {
  color: #58d9f9;
  font-weight: bold;
  background: transparent !important;
}

.storePage .el-table th.el-table__cell.is-leaf {
  /*border-bottom: none;*/
}
</style>